import type { Voice } from "@/app/_data/voices";
import type { IImage } from "@components/types/media";

/**
 * Gets the appropriate image for a voice based on size
 * @param voice - The voice object
 * @param size - The desired image size ("md" for orb, "xl" for face when available)
 * @returns IImage object or undefined
 */
export function getVoiceImage(voice: Voice | undefined, size: "md" | "xl"): IImage | undefined {
  if (!voice) {
    return undefined;
  }

  if (size === "xl" && voice.imageFace && typeof voice.imageFace === "string") {
    return { src: `/assets/images/voices/faces/${voice.imageFace}` };
  }

  if (size === "xl" && voice.imageFace && typeof voice.imageFace !== "string") {
    return { resource: voice.imageFace };
  }

  if (voice.image && typeof voice.image === "string") {
    return { src: `/assets/images/voices/orbs/${voice.image}` };
  }

  if (voice.image && typeof voice.image !== "string") {
    return { resource: voice.image };
  }

  return undefined;
}
